import Dropdown from './_dropdown.js'
import SuspendedSelectionLabel from './_suspended-selection-label.js'

export default {
  name: 'OddsDropdown',
  values: {
    dropdown: {
      configSet: Dropdown,
      configValues: {
        style: {
          rootContainer: {
            flexGrow: 0,
          },
        },
      },
    },
    dropdownHighlight: {
      configSet: Dropdown,
      configValues: {
        style: {
          rootContainer: {
            flexGrow: 0,
          },
        },
      },
    },
    suspendedSelectionLabel: {
      configSet: SuspendedSelectionLabel,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
